import Events from '../utils/events';
import { EV_ADD_TO_CART, EV_PURCHASE } from './events';

declare const dataLayer: any[];

export const goal = (...args: any[]) => {
  window.mtr?.goal(...args);
};

export const session = (goalId: string, session: ITriggerbeeSession) => {
  if (window.mtr_custom) {
    window.mtr_custom = window.mtr_custom || {};
    window.mtr_custom.session = { ...window.mtr_custom, ...session };
    goal(goalId);
  }
};

export default () => {
  if (!SSR) {
    document.addEventListener('afterTriggerbeeReady', () => {
      window.mtr?.inject('/triggerbee/update-cookies');
    });

    document.addEventListener('onTriggerbeeWidgetOpened', (event: any) => {
      if (window.dataLayer) {
        dataLayer.push({
          event: 'onTriggerbeeWidgetOpened',
          campaignName: event.detail.campaignName,
          campaignId: event.detail.campaignId,
          id: event.detail.id,
          variantName: event.detail.variantName,
        });
      }
    });

    document.addEventListener('onTriggerbeeWidgetClosed', (event: any) => {
      if (window.dataLayer) {
        dataLayer.push({
          event: 'onTriggerbeeWidgetClosed',
          campaignName: event.detail.campaignName,
          campaignId: event.detail.campaignId,
          id: event.detail.id,
          variantName: event.detail.variantName,
        });
      }
    });

    document.addEventListener('onBeforeTriggerbeeFormSubmitted', (event: any) => {
      if (window.dataLayer) {
        dataLayer.push({
          event: 'onBeforeTriggerbeeFormSubmitted',
          campaignName: event.detail.campaignName,
          campaignId: event.detail.campaignId,
          id: event.detail.id,
          variantName: event.detail.variantName,
        });
      }
    });

    document.addEventListener('onAfterTriggerbeeFormSubmitted', (event: any) => {
      if (window.dataLayer) {
        dataLayer.push({
          event: 'onAfterTriggerbeeFormSubmitted',
          campaignName: event.detail.campaignName,
          campaignId: event.detail.campaignId,
          id: event.detail.id,
          variantName: event.detail.variantName,
        });
      }
    });

    document.addEventListener('onTriggerbeeWidgetButtonClicked', (event: any) => {
      if (window.dataLayer) {
        dataLayer.push({
          event: 'onTriggerbeeWidgetButtonClicked',
          campaignName: event.detail.campaignName,
          campaignId: event.detail.campaignId,
          id: event.detail.id,
          variantName: event.detail.variantName,
          url: event.detail.url,
        });
      }
    });

    document.addEventListener('onTriggerbeeWidgetStateSwitched', (event: any) => {
      if (window.dataLayer) {
        dataLayer.push({
          event: 'onTriggerbeeWidgetStateSwitched',
          campaignName: event.detail.campaignName,
          campaignId: event.detail.campaignId,
          id: event.detail.id,
          variantName: event.detail.variantName,
          stateId: event.detail.stateId,
        });
      }
    });
  }

  Events.on(EV_ADD_TO_CART, () => {
    try {
      window.mtr?.goal('addToCart');
    } catch (e) {
      console.warn('Tracking failed', e);
    }
  });

  Events.on(EV_PURCHASE, (_: any[], order: Commerce.IOrderResponse) => {
    try {
      session('purchase', { email: order.customer.email });
    } catch (e) {
      console.warn('Tracking failed', e);
    }
  });
};
